export enum AttributeClass {
  Tag = 'tag',
  TimeEntryTag = 'time_entry_tag'
}
